<template>
    <div class="error-page">
        <div class="error-content">
            <van-empty image="error" :description="message" :title="title">
            </van-empty>
        </div>
    </div>
</template>

<script setup>
// Props
defineProps({
    title: {
        type: String,
        default: '出错了'
    },
    message: {
        type: String,
        default: '网络请求失败，请稍后重试'
    }
})

</script>

<style scoped>
.error-page {
    height: calc(100vh - 84px);
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f7f8fa;
}

.error-content {
    text-align: center;
    width: 100%;
}
</style>